import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3079ee1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "authOptIn",
  class: "ExperimentCOptInPopUp"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftContentContainer = _resolveComponent("LeftContentContainer")!
  const _component_RightContentContainer = _resolveComponent("RightContentContainer")!
  const _component_PopUp = _resolveComponent("PopUp")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopUp, {
      identifier: "ExperimentCOptInPopUp",
      appIdentifier: _ctx.appIdentifier
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_LeftContentContainer, {
            onNotNow: _ctx.notNow,
            onAccept: _ctx.accept
          }, null, 8 /* PROPS */, ["onNotNow", "onAccept"]),
          _createVNode(_component_RightContentContainer)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["appIdentifier"])
  ]))
}